<mat-dialog-content class="terms">
	<button class="o-modal-dismiss">
		<epi-icon
			mat-dialog-close
			use="close"
			size="24"
		></epi-icon>
	</button>
	<epi-heading
		level="2"
		appears-as="1"
		color="primary"
	>
		Automatic Renewal Terms
	</epi-heading>

	<section class="u-margin-top-x-small">
		<p><span class="m--bold">You acknowledge that your policy will automatically renew</span>,
		 and at that time, the premium may increase. If you wish to stop automatic renewal of your policy, you can do so by clicking the link
		 in your renewal email which you will receive at least 35 days prior to the renewal. You must notify us no later than the day before
		 your policy’s renewal effective date. If you choose not to cancel the automatic renewal of your policy,
		 you will be unable to cancel the automatic renewal of your policy until your next renewal window.</p>
		<p class="u-margin-top-small"> By enrolling in this policy, you authorize us to charge your
		chosen payment method for your premium and any applicable fees. Your monthly (or annual) payment will be charged on the date listed
		on your declarations page.</p>
		<p class="u-margin-top-small">To cancel your policy at any time, you can contact us and specify the cancellation date. If you cancel, we will provide a pro-rated refund of any unused premium based on your last date of coverage.</p>
	</section>
</mat-dialog-content>
